const v14 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        optimisationThumbsTable: {
          ...state.options.tableViews.optimisationThumbsTable,
          "e4 min Reach": true,
        },
        optimisationIntrosTable: {
          ...state.options.tableViews.optimisationThumbsTable,
          "e4 min Reach": true,
        },
        optimisationFinalisationTable: {
          ...state.options.tableViews.optimisationThumbsTable,
          "e4 min Reach": true,
        },
        optimisationSequenceTable: {
          ...state.options.tableViews.optimisationThumbsTable,
          "e4 min Reach": true,
        },
      },
    },
  };
};

export default v14;
